import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isColumnResizable as o } from "./utils.js";
import { ref as s } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function b() {
  const i = s({});
  function t(e) {
    return i.value[e];
  }
  function r(e, n) {
    o(e) && "key" in e && (i.value[e.key] = n);
  }
  function a() {
    i.value = {};
  }
  return {
    getResizableWidth: t,
    doUpdateResizableWidth: r,
    clearResizableWidth: a
  };
}
export {
  b as useResizable
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-resizable.js
// module id = 1618
// module chunks = 41